import React, { useState } from 'react';
import CookieBanner from './CookieBanner';
import {
  CONSENT_ACCEPTED,
  CONSENT_REJECTED,
  getConsent,
  setConsent,
} from '../../utils/consent';
import { clearAnalyticsCookies, loadAnalytics, trackPageView } from '../../utils/analytics';

// Tüm durum burada; alt bileşenler yalnızca sunum yapar.
// Karar verildikten sonra ekranda hiçbir şey kalmıyor: ne banner ne de
// yüzen bir çerez butonu. Tercihini değiştirmek isteyen /cookie-policy
// sayfasındaki butonu kullanıyor.
const CookieConsent = () => {
  const [isBannerVisible, setIsBannerVisible] = useState(() => getConsent() === null);

  const handleAccept = () => {
    setConsent(CONSENT_ACCEPTED);
    loadAnalytics();
    trackPageView(window.location.pathname + window.location.search);
    setIsBannerVisible(false);
  };

  const handleReject = () => {
    const wasAccepted = getConsent() === CONSENT_ACCEPTED;
    setConsent(CONSENT_REJECTED);

    if (wasAccepted) {
      // Çalışan bir GA scripti geri alınamaz. Dürüst tek yol: çerezleri
      // temizleyip sayfayı yeniden yüklemek.
      clearAnalyticsCookies();
      window.location.reload();
      return;
    }

    setIsBannerVisible(false);
  };

  if (!isBannerVisible) return null;

  return <CookieBanner onAccept={handleAccept} onReject={handleReject} />;
};

export default CookieConsent;
